"use client";
import Image from "next/image";
import { Loader2 } from "lucide-react";

const CommonButton = ({
  text,
  bgColor,
  hoverColor,
  textColor,
  onClick = () => {},
  className,
  svgImages,
  isLoading = false,
  isShowSubmitButton = true
}) => {
  const style = {
    color: textColor,
    backgroundColor: bgColor // keep dynamic background
  };
  return (
    <button
      onClick={onClick}
      style={style}
      disabled={isLoading || !isShowSubmitButton}
      className={`
        flex items-center justify-center
         text-23px-normal
        gap-[clamp(12px,1vw,20px)]
        px-[clamp(10px,1vw,15px)] py-[clamp(4px,0.5vw,6px)]
        rounded-[100px] md:rounded-[100px] [@media(min-width:2000px)]:rounded-[100px]
        ${className || ""}
        ${isLoading || !isShowSubmitButton ? "opacity-70 cursor-not-allowed" : "cursor-pointer"}
      `}
    >
      {isLoading ? (
        <>
          <span>{text}</span>
          <Loader2 className="animate-spin w-5 h-5" style={{ color: textColor }} />
        </>
      ) : (
        <>
          <span>{text}</span>
          {svgImages && (
            <>
              {typeof svgImages === "string" ? (
                <Image
                  className="object-cover 2xl:w-5.5 xl:w-4 w-4"
                  src={svgImages}
                  alt="Arrow Icon"
                  width={24}
                  height={24}
                />
              ) : (
                svgImages
              )}
            </>
          )}
        </>
      )}
    </button>
  );
};

export default CommonButton;
